import {makeAutoObservable, autorun} from 'mobx';
import safeJsonParse from '../../util/safeJsonParse';
import pick from '../../util/pick';
import addHours from 'date-fns/addHours';

const LS_NAME = 'SPUDDY_AUTH';

const DEFAULT_STRUCTURE = {
  createdAt: '',
  expiresAt: '',
  refreshToken: '',
  token: '',
  userId: '',
};

const ALLOWED_KEYS = Object.keys(DEFAULT_STRUCTURE);

class Auth {
  constructor() {
    this.initialize(safeJsonParse(sessionStorage.getItem(LS_NAME)));

    makeAutoObservable(this, {
      tokenRefreshable: false,
      tokenExpired: false,
      shouldRefreshTokenManually: false,
    });

    autorun(() => {
      sessionStorage.setItem(LS_NAME, JSON.stringify(pick(this, ALLOWED_KEYS)));
    });
  }

  get tokenRefreshableEdgeDate() {
    return this.createdAt
      ? addHours(new Date(this.createdAt), 16)
      : new Date(0);
  }

  get tokenRefreshable() {
    return this.createdAt ? Date.now() < this.tokenRefreshableEdgeDate : false;
  }

  get tokenExpired() {
    return this.expiresAt ? Date.now() >= new Date(this.expiresAt) : true;
  }

  get shouldRefreshTokenManually() {
    return this.tokenExpired && !this.tokenRefreshable;
  }

  initialize(authObject) {
    Object.assign(this, DEFAULT_STRUCTURE, pick(authObject, ALLOWED_KEYS));
  }

  reset() {
    this.initialize(null);
  }
}

export default Auth;
